module.exports = __webpack_public_path__ + "img/jjfa_10.eb3d8728.jpg";